module.exports = __webpack_public_path__ + "img/管理-5.8b8b6bd1.jpeg";